/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventscalendarpreviousmonth3Inputs */

const en_eventscalendarpreviousmonth3 = /** @type {(inputs: Eventscalendarpreviousmonth3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous month`)
};

const de_eventscalendarpreviousmonth3 = /** @type {(inputs: Eventscalendarpreviousmonth3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voriger Monat`)
};

/**
* | output |
* | --- |
* | "Previous month" |
*
* @param {Eventscalendarpreviousmonth3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventscalendarpreviousmonth3 = /** @type {((inputs?: Eventscalendarpreviousmonth3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventscalendarpreviousmonth3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventscalendarpreviousmonth3(inputs)
	return de_eventscalendarpreviousmonth3(inputs)
});
export { eventscalendarpreviousmonth3 as "eventsCalendarPreviousMonth" }